import React, {useState,lazy,Suspense} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEnvelope, faDownload, faAddressCard} from '@fortawesome/free-solid-svg-icons';
import {Loading} from "@gull"
import { Modal } from "react-bootstrap";

const SendMultipleCardEmailForm = lazy(() => import('./form/SendMultipleCardEmailForm'));

const PaymentAbonnementCard = (props) =>{
    const t = useTranslate();

    const [showMail,setShowMail]=useState(false) // Modal mail

    const callback = () =>{
        setShowMail(true)
    }

    const closeMailModal = () =>{
        setShowMail(false)
    }

    return(<>
        <Modal size="lg" show={showMail} onHide={() => closeMailModal()}>
            <Modal.Header closeButton>
                <Modal.Title>{t('sendDocEmail')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Suspense fallback={<Loading></Loading>} >
                    <SendMultipleCardEmailForm  closeModal={closeMailModal} currentTicket={props.currentTicket} abonnementCardDatas={props.abonnementCardDatas}/>
                </Suspense>
            </Modal.Body>
        </Modal>
        <div className='row'>
            <div className='col'>
                <span>{'Envoyer les cartes d\'abonnements par e-mail: '}</span>
                <OverlayTrigger
                    placement="bottom"
                    overlay={
                        <Tooltip id={`tooltip-${props.index}`}>
                            {t('sendDocEmail')}
                        </Tooltip>
                    }
                >
                    <span onClick={() => callback(props.currentTicket)} style={{cursor:'Pointer', color:'#FF8919'}}><FontAwesomeIcon icon={faEnvelope} /></span>
                </OverlayTrigger>  
            </div>
        </div>
        {props.abonnementCardDatas.length!=0 && props.abonnementCardDatas.map(value => {
            return (
                <div className='row'>
                    <div className='col'>
                        <span>{value.abonnement_achat_article.name}: </span>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip id={`tooltip-${value.id}`}>
                                    {t('download')}
                                </Tooltip>
                            }
                        >
                            <a style={{cursor:'Pointer', color:'#FF8919'}} href={'/session/abonnement_card/download/'+value.id+'/'+value.token} target='_blank' ><FontAwesomeIcon icon={faDownload} /></a>
                        </OverlayTrigger>
                    </div>
                </div>
            )
        })}
    </>
    )

}

export default PaymentAbonnementCard;